import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("user-products.service");

const PRODUCTS_ENDPOINT = `/user/products`;

export const userProductsService = {
    getAll({ page, size, search } = {}) {
        logger.debug("userProductsService.getAll()");
        return ajaxCall
            .get(PRODUCTS_ENDPOINT, {
                params: { page, size, search },
            })
            .catch(handleErrorByMessage());
    },
};
